import {
  styled,
  Drawer,
  useMediaQuery,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SidebarData from './SidebarData';

const headerStyle = import.meta.env.VITE_ENV_VERSION !== 'prod' ? '#111827' : '#00B0B9';

const StyledDrawer = styled(Drawer)(() => ({
  width: 220,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 220,
    boxSizing: 'border-box',
    background: headerStyle,
  },
}));
// TODO: style={{}}を使わずに、classNameで定義する
const Sidebar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <>
      <Toolbar />
      <List>
        {SidebarData.map((item, index) => (
          <ListItemButton
            component={Link}
            to={item.link}
            key={index}
            sx={{
              color: 'white',
              '&:hover': { backgroundColor: headerStyle },
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItemButton>
        ))}
      </List>
    </>
  );

  return (
    <>
      <div
        style={{
          width: isSidebarOpen ? 260 : 40,
          transition: 'width 0.3s',
          background: headerStyle,
          color: 'white',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: 1000,
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        {/* 閉じている時は細いバー＋テキストをクリックで開く */}
        {!isSidebarOpen && (
          <div
            style={{
              writingMode: 'vertical-rl',
              textAlign: 'center',
              width: '100%',
              height: '100%',
              fontWeight: 'bold',
              letterSpacing: '0.1em',
              userSelect: 'none',
              cursor: 'pointer',
              zIndex: 1000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className="text-2xl font-bold"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            MENU
          </div>
        )}
        {/* 開いている時はSidebar＋閉じるボタン */}
        {isSidebarOpen && (
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <div>
              <StyledDrawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={isMobile ? mobileOpen : true}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
              >
                {drawer}
              </StyledDrawer>
            </div>
            {/* 閉じるボタン */}
            <button
              style={{
                writingMode: 'vertical-rl',
                position: 'absolute',
                right: 0,
                background: 'transparent',
                border: 'none',
                color: 'white',
                zIndex: 1000,
                cursor: 'pointer',
                fontWeight: 'bold',
                letterSpacing: '0.1em',
                userSelect: 'none',
                height: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              className="text-2xl font-bold"
              aria-label="サイドバーを閉じる"
              onClick={(e) => {
                e.stopPropagation();
                setIsSidebarOpen(false);
              }}
            >
              CLOSE
            </button>
          </div>
          // </div>
        )}
      </div>
    </>
  );
};
export default Sidebar;
